var map = {
	"./background-st-andrews.jpg": "8cac",
	"./climbing.jpg": "1554",
	"./golf.jpg": "6c70",
	"./hacking.jpg": "3e3f",
	"./honors.jpg": "aadc",
	"./logo.png": "cf05",
	"./me.jpg": "b0df",
	"./mylittletraderbot.jpg": "b84d",
	"./pavlova.jpg": "bc01",
	"./playgroundnews.png": "60b3",
	"./takephotoapp.png": "4be0",
	"./travel.jpg": "5710",
	"./volunteer.jpg": "ecf3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";